import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import terms from "@/content/terms";
import privacy from "@/content/privacy";
import shipping from "@/content/shipping";
import returns_ from "@/content/returns";
import dmca from "@/content/dmca";

const DOCS = {
  terminos: { title: "Términos de Servicio", content: terms },
  privacidad: { title: "Política de Privacidad", content: privacy },
  envios: { title: "Política de Envíos", content: shipping },
  devoluciones: { title: "Devoluciones y Reembolsos", content: returns_ },
  dmca: { title: "Aviso DMCA", content: dmca },
};

export default function Legal() {
  const { doc } = useParams();
  const entry = DOCS[doc];

  if (!entry) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-16 text-center">
        <h1 className="font-display font-black text-2xl uppercase">Documento no encontrado</h1>
        <Link to="/" className="text-drelo-primary underline mt-4 inline-block">Volver al inicio</Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <div className="flex gap-2 flex-wrap mb-8 text-sm">
        {Object.entries(DOCS).map(([key, d]) => (
          <Link
            key={key}
            to={`/legal/${key}`}
            className={`px-3 py-1.5 rounded-full border ${key === doc ? "bg-drelo-primary text-white border-drelo-primary" : "text-drelo-muted hover:border-drelo-primary"}`}
          >
            {d.title}
          </Link>
        ))}
      </div>
      <article className="prose prose-sm md:prose-base max-w-none prose-headings:font-display prose-headings:uppercase prose-a:text-drelo-primary">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{entry.content}</ReactMarkdown>
      </article>
    </div>
  );
}
